import { render, staticRenderFns } from "./TickerTextMultipleLines.vue?vue&type=template&id=a02fbe92&scoped=true"
import script from "./TickerTextMultipleLines.vue?vue&type=script&lang=js"
export * from "./TickerTextMultipleLines.vue?vue&type=script&lang=js"
import style0 from "./TickerTextMultipleLines.vue?vue&type=style&index=0&id=a02fbe92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02fbe92",
  null
  
)

export default component.exports